import { propTypes, withFormsy } from 'formsy-react'
import _ from 'lodash';
import React, { Component } from 'react'
import { Grid } from 'semantic-ui-react';


class DGMultiCheckBoxGroup extends Component {

    changeValue = (event) => {
        

        //const currentValue = this.props.value;

        let values = this.props.value ? [...this.props.value]: [];
        

        if (event.currentTarget.checked) {
            if(_.isEmpty(values)){
                values = [];
            }
            values.push(event.currentTarget.value);
            /*if (!currentValue || currentValue.length == 0) {

                

            }
            else {

                currentValue.push(+event.currentTarget.value);
                values = currentValue;

            }*/
        }
        else {
            _.pull(values, event.currentTarget.value);

        }

        if(values.length == 0){
            
            this.props.setValue(null);
            
        }
        else{
            
            this.props.setValue(values);
            
        }
        


    }

    componentDidMount(){

        let values = [];
        const fields = this.props.fields;
        fields.map((field, fieldIndex) => {
            if(field.value === 'checked'){
                values.push(field.fieldID.toString());
            }
        });
        //const values=[1,2];
        
        this.props.setValue(values);
        

    }

    

    render() {
        
        const childrenWithProps = React.Children.map(this.props.children, child => {
            // checking isValidElement is the safe way and avoids a typescript error too

            if (React.isValidElement(child)) {
                return React.cloneElement(child);
            }

            return child;
        });
        const fields = this.props.fields;
        
        return (
            <>
                {/*<div className="ui grid">
                    {childrenWithProps.map(child => {
                        return <div className="eight wide column">{child}</div>
                    })}
                </div>*/}
                <Grid key={`multicheckboxgroup-grid`}>
                    {
                        fields && fields.map((field, fieldIndex) => {
                            return <Grid.Column computer={8} mobile={16} key={`multicheckboxgroup-grid-column-${field.fieldID}`}>
                                <div className={`chkbox-field ${!this.props.isPristine && !this.props.isValid ? 'error' : ''}`} key={`chkbox-field-${field.fieldID}`}>
                                    <label className="checkbox" key={`chkbox-${field.fieldID}`}>

                                        <input type="checkbox" key={`chkbox-ctrl-${field.fieldID}`} name={this.props.name} onChange={this.changeValue} value={field.fieldID} checked={_.indexOf(this.props.value, field.fieldID.toString()) >= 0} />


                                        <span key={`chkbox-icon-${field.fieldID}`} className="checkbox__icon"></span>
                                        <span key={`chkbox-label-${field.fieldID}`} className="text">{field.name}</span>
                                    </label>
                                </div>
                            </Grid.Column>
                        })
                    }
                </Grid>

                {
                    !this.props.isPristine && !this.props.isValid &&
                    <div className="error" key={`chkbox-error-${this.props.name}`}>
                        {this.props.errorMessage}
                    </div>
                }
            </>
        );
    }
}

DGMultiCheckBoxGroup.propTypes = {
    ...propTypes
}

export default withFormsy(DGMultiCheckBoxGroup)
